export const ErrorType = {
	TryCatch: 'tryCatch',
	Unknown: 'unknown',
	Ui: 'ui',
	Network: 'network',
	Backend: 'backend',
	Auth: 'auth',
	ValidationError: 'validationError',
	TypeError: 'typeError',
	ResourceError: 'resourceError',
} as const;
export declare type ErrorType = (typeof ErrorType)[keyof typeof ErrorType];
